/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { PageStateComponent } from './page-state';
export * from './page-state-constants';
export * from './page-state';
export function definePageStateComponent() {
    defineCustomElement(PageStateComponent);
}
